import BasicLayout from '@/layouts/BasicV2';
import {wrapModelLoaderAsBeforeRouterEnterHook} from '../lib/model';

import {findV2Config} from '../layouts/config/leftSidebar';

export default [
    {
        path: '/user/:userid/findv2',
        name: 'findV2',
        component: BasicLayout,
        children: [
            {
                path: '',
                name: 'findV2',
                component: () => import('@/layouts/ContentLayout'),
                props: {
                    leftNavConfig: findV2Config
                },
                children: [
                    {
                        path: 'image',
                        name: 'findV2Image',
                        meta: {
                            title: '图片灵感',
                            authorizedRole: 'digital_human_list',
                            anyMatch: {
                                allowInnerUser: true,
                                authorizedRole: ['digital_human_list']
                            }
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'ImageCreate', loader: () => import('../model/ImageCreate')}
                        ]),
                        component: () => import('@/views/V2/Find/image/Index.vue')
                    },
                    {
                        path: 'video',
                        name: 'findV2Video',
                        meta: {
                            title: '灵感推荐',
                            authorizedRole: 'is_qingduo_uc_user'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'VideoCreate', loader: () => import('../model/VideoCreate')},
                            {name: 'AiChatCreate', loader: () => import('../model/AiChatCreate')}
                        ]),
                        component: () => import('@/views/V2/Find/video/Index.vue')
                    },
                    {
                        path: 'script',
                        name: 'findV2Script',
                        meta: {
                            title: '视频灵感',
                            authorizedRole: 'qingduo_scenery_image_generate_video',
                            forbidOuterUser: true
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'VideoCreate', loader: () => import('../model/VideoCreate')},
                            {name: 'AiChatCreate', loader: () => import('../model/AiChatCreate')}
                        ]),
                        component: () => import('@/views/V2/Find/script/Index.vue')
                    },
                    {
                        path: 'scriptNew',
                        name: 'findV2ScriptNew',
                        meta: {
                            title: '视频灵感',
                            authorizedRole: 'qingduo_image_digital'
                        },
                        beforeEnter: wrapModelLoaderAsBeforeRouterEnterHook([
                            {name: 'VideoCreate', loader: () => import('../model/VideoCreate')},
                            {name: 'AiChatCreate', loader: () => import('../model/AiChatCreate')}
                        ]),
                        component: () => import('@/views/V2/Find/script/Index.vue')
                    }
                ]
            }
        ]
    }
];
